/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RobotIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACIklEQVR4nO1UTWsTYRBe9aB4EgRBQYWKeOpFf4BfoNHsO89sYHcmUQn+BBURvAT06i+wVKVX9VDxouLJL2ihFgVFBEE9eGoRLPSgJjKb3W6y3WZXvXZgIJv3eeaZr/f1vHX7Fzvcbm8h6IxjeVOGJehbw/q+v7WyALHcINYeQecrCMwb1kEmKwUH5IiD/CbIMtAaL8e3xg1rIj7keKmAY5nrZ6SXOp3ORiINCHLHQT8Qy1LskPeO9ZaPJhvGsEnFM57nbVgzuM9yIin3K5GSg76LiaM8FhM41i/xN2kwInt9khA/E2u3NHjm3YTTsxiFwZnPbY97P0SUJQe5CTQdILttu8x9P9wTV8gy0W9bxrEYQXBmZ1H2US74vSA4u6NsZoYh6P0hLkXni4Y7sZIFy916vTFGkMcO+p2gj043WntTrP22/9IzZtk3KFK4sgR5lgLqjeZ+xzI7VDrL3EAyr3Nns0ThgWzw8TblBFg/pgCgvY1YpxzkYT9beUnQ5wPtfEHQV3bmWB4Q6+2Ekwp8W90i6I+sh3qhrPd5W7kL/dVdLgIsDJT900TCMNzklZhhiOWig/7KZqALq4AEeVqw35+I9RpRdNRWr1arbTYn0l0u0GMOcj3BDPEK74LPcuovL1dvrUsHRCcLy3WQK/8p0iWWyyN7ai9ifkWpghvH2uZVNebWIQe56lim7UEjlsV4+LHLYvLITRvGD6KDlQOvm5ezPwJQxb1+u6BWAAAAAElFTkSuQmCC)
 */
export const RobotIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.89 13.46a1 1 0 0 1-1.78-.9L7 13l-.9-.45.01-.01.01-.02a2.42 2.42 0 0 1 .14-.23c.1-.14.23-.31.4-.5.37-.36.98-.79 1.84-.79.86 0 1.47.43 1.83.8a3.28 3.28 0 0 1 .55.72v.02h.01v.01L10 13l.9-.45a1 1 0 0 1-1.79.9 1.28 1.28 0 0 0-.19-.25c-.14-.13-.28-.2-.42-.2-.14 0-.28.07-.42.2a1.28 1.28 0 0 0-.19.25ZM13.55 13.9a1 1 0 0 0 1.34-.44c0-.02.02-.04.04-.06.03-.05.08-.13.15-.2.14-.13.28-.2.42-.2.14 0 .28.07.42.2a1.28 1.28 0 0 1 .19.25 1 1 0 0 0 1.78-.9L17 13l.9-.45-.01-.01-.01-.02a2.26 2.26 0 0 0-.14-.23 3.28 3.28 0 0 0-.4-.5c-.37-.36-.98-.79-1.84-.79-.86 0-1.47.43-1.83.8a3.28 3.28 0 0 0-.55.72v.02h-.01v.01L14 13l-.9-.45a1 1 0 0 0 .45 1.34Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 21c5.52 0 10-1.86 10-6 0-5.59-2.8-10.07-4.26-11.67a1 1 0 1 0-1.48 1.34 14.8 14.8 0 0 1 2.35 3.86A10.23 10.23 0 0 0 12 6C9.47 6 7.15 7.02 5.4 8.53a14.8 14.8 0 0 1 2.34-3.86 1 1 0 1 0-1.48-1.34A18.65 18.65 0 0 0 2 15c0 4.14 4.48 6 10 6Zm0-12c3.87 0 7 2 7 4.2S15.87 17 12 17s-7-1.6-7-3.8C5 11 8.13 9 12 9Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
